import { render, staticRenderFns } from "./ModalRemoveGestor.vue?vue&type=template&id=5757c820&scoped=true"
import script from "./ModalRemoveGestor.vue?vue&type=script&lang=ts"
export * from "./ModalRemoveGestor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5757c820",
  null
  
)

export default component.exports